import React from 'react';

type FaProps = {
    icon: string;
    className?: string;
};

export class Fa extends React.PureComponent<FaProps> {
    static displayName = 'Fa';

    render() {
        const {icon, className} = this.props;

        return (
            <i className = {`fas fa-${icon} ${className}`} />
        );
    }
}
